import { UserRole } from '@40seas/entities/users';
import { z } from 'zod';

import { FromSchema, ZodDate } from '@40seas/entities/common';

export const InvoiceConfirmationsScheme = z
    .object({
        buyer: ZodDate.optional(),
        supplier: ZodDate.optional(),
        factor: ZodDate.optional(),
    })
    .strict();

export class InvoiceConfirmations extends FromSchema(InvoiceConfirmationsScheme) {
    buyer?: Date;
    supplier?: Date;
    factor?: Date;

    static isEligible(confirmations: InvoiceConfirmations | undefined): boolean {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore - Fix TS FS-3199
        return !!confirmations.supplier && !!confirmations.factor && !confirmations.buyer;
    }
}

export const RoleToConfirmationFieldMap = new Map<UserRole, keyof InvoiceConfirmations>([
    [UserRole.Buyer, 'buyer'],
    [UserRole.Supplier, 'supplier'],
    [UserRole.Factor, 'factor'],
]);
